import type { ReactNode } from 'react';
import { ActionRow } from './ActionRow';
import styles from './ui.module.css';

/**
 * Полоса действий в КОНЦЕ формы: главное действие и отказ от него.
 *
 * Своего шва у неё не было — формы собирали её из `Gutter` и `ActionRow`, а
 * `Gutter` вертикального ритма не держит вовсе. Отбить её было нечем, и
 * кнопки стояли вплотную к последнему полю. Шов теперь её собственный, и
 * трём формам — предмета, питомца и способности — он один.
 */
export function FormActions({ children }: { children: ReactNode }) {
  return (
    <div className={styles.formActions}>
      <ActionRow>{children}</ActionRow>
    </div>
  );
}
